import React, { useState } from 'react'
import { firestore } from '../../../firebase';

function EditChoice({choice, quizId, questionId}) {

    const [choiceText, setChoiceText] = useState(choice.choice);
    const [isCorrect, setIsCorrect] = useState(choice.is_correct);

    const [error, setError] = useState("");
    const [message, setMessage] = useState("");

    async function editHandler(e) {
        e.preventDefault();
        try {
            const choiceRef = firestore.collection("quiz").doc(quizId).collection("questions").doc(questionId).collection("choices").doc(choice.id);
            const data = {
                is_correct: Boolean(isCorrect),
                choice: choiceText
            }
            choiceRef.update(data);
            setMessage("Oppdatert");
        } catch (error) {
            setError("Kunne ikke oppdatere");
        }
    }

    return (
        <div className="col-12">
            <form onSubmit={editHandler}>

                <label>Choice</label>
                <input className="form-control mb-2" value={choiceText} onChange={e => setChoiceText(e.target.value)} />

                <label>Is correct?</label>
                <select className="browser-default custom-select mb-2" onChange={e => setIsCorrect(e.target.value)}>
                    <option value={isCorrect}>{isCorrect ? "Korrekt" : "Ikke korrekt"}</option>
                    <option value="false">Ikke korrekt</option>
                    <option value="true">Korrekt</option>
                </select>

                {error && <div className="alert alert-danger">{error}</div>}
                {message && <div className="alert alert-success">{message}</div>}
                <button className="btn btn-success btn-block">Lagre endringer</button>

            </form>
        </div>

    )

}
export default EditChoice